import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import { TextInput, FormInputError } from "@toddle-edu/ds-web";
import classes from "./InputNumberFieldV2.scss";
import classNames from "classnames";
import { inputHTMLAttributes } from "Constants";

class InputNumberFieldV2 extends UIBaseComponent {
  constructor(props) {
    super(props);
    this.errorId = _.uniqueId("form-error-");
  }
  handleKeyPress = e => {
    const { handleKeyPress } = this.props;
    if (e.key === "Enter") {
      const param = {};
      param[e.target.name] = e.target.value;
      if (this.props.onEnter) {
        this.props.onEnter(param);
      }
    }
    if (handleKeyPress) {
      handleKeyPress(e);
    }
  };

  handleChange = e => {
    const newValue = e.target.value;
    const updatedValue = newValue.replace(/\D/g, "");

    this.updateValue(updatedValue);
  };

  renderEdit = () => {
    const {
      size,
      disabled,
      value,
      textInputLabel,
      inputStyle,
      ...rest
    } = this.props;

    const errorMessage = this.state.error ? this.state.error : "";

    const containerClass = classNames("w-full", classes.containerClass);

    return (
      <div className={containerClass}>
        <TextInput
          {..._.pick(rest, inputHTMLAttributes)}
          size={size}
          style={inputStyle}
          onChange={this.handleChange}
          ref={this.updateInputRef}
          error={errorMessage}
          label={textInputLabel}
          disabled={disabled}
          onKeyPress={this.handleKeyPress}
          onBlur={e => this.onBlur({ value: e.target.value })}
          onFocus={e => this.onFocus({ value: e.target.value })}
          value={value ? value : ""}
          aria-describedby={this.errorId}
        />
        <FormInputError
          id={this.errorId}
          {...(!_.isEmpty(errorMessage) && {
            className: classes.errorClass,
            error: errorMessage,
          })}
        />
      </div>
    );
  };
}

InputNumberFieldV2.defaultProps = {
  ...UIBaseComponent.defaultProps,
  inputStyle: {},
  size: "medium",
  autoFocus: false,
  showErrorText: false,
  ["data-test-id"]: "input-form-number",
};

InputNumberFieldV2.propTypes = {
  ...UIBaseComponent.propTypes,
  onBlur: PropTypes.func,
  inputStyle: PropTypes.object,
  onEnter: PropTypes.func,
  updateInputRef: PropTypes.func,
  showErrorText: PropTypes.bool,
  leadingIcon: PropTypes.element,
  trailingIcon: PropTypes.element,
};

export default InputNumberFieldV2;
